import React, { useEffect, useRef, useState } from "react";
import MaskingAudioUi from "./MaskingAudioUi";
import {
  Badge,
  Box,
  Card,
  CardContent,
  Slider,
  Typography,
} from "@mui/material";
import { Close, HighlightOff, VolumeUp } from "@mui/icons-material";
// import beach from '../../assets/sound/beach.mp3'
// import birds from '../../assets/sound/birds.mp3'
// import brook from '../../assets/sound/brook.mp3'
// import cicadas from '../../assets/sound/cicadas.mp3'
// import crickets from '../../assets/sound/crickets.mp3'
// import fire from '../../assets/sound/fire.mp3'
// import frog from '../../assets/sound/frog.mp3'
// import highway from '../../assets/sound/highway.mp3'
// import rainthunder from '../../assets/sound/rainthunder.mp3'
// import underwater from '../../assets/sound/underwater.mp3'
// import whale from '../../assets/sound/whale.mp3'
// import wind from '../../assets/sound/wind.mp3'
import { CREATE_CUSTOM_THERAPY } from "../../utils/constants";
import { DndProvider, useDrag } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import beach from "../../assets/images/soundimg/OceanWaves.svg";
import birds from "../../assets/images/soundimg/Birds.svg";
import brook from "../../assets/images/soundimg/Brook.svg";
import cicadas from "../../assets/images/soundimg/Cicadas.svg";
import crickets from "../../assets/images/soundimg/Crickets.svg";
import fire from "../../assets/images/soundimg/Fire.svg";
import frog from "../../assets/images/soundimg/Frog.svg";
import highway from "../../assets/images/soundimg/highway.svg";
import rain_thunder from "../../assets/images/soundimg/Thunder.svg";
import under_water from "../../assets/images/soundimg/UnderWater.svg";
import whale from "../../assets/images/soundimg/Whales.svg";
import wind from "../../assets/images/soundimg/Wind.svg";
import pink_noise from "../../assets/images/pink_noise.svg";
import white_noise from "../../assets/images/white_noise.svg";
import brown_noise from "../../assets/images/brown_noise.svg";
import violet_noise from "../../assets/images/violet_noise.svg";
import music from "../../assets/images/Music.svg";
import { CreatefilefirebaseCreateurlApi } from "../../apis/file.api";
import { FetchAudioApi } from "../../apis/therapy.api";
import { callApiAction } from "../../store/actions/commonAction";
import { useDispatch, useSelector } from "react-redux";
import SelectedSounds_img from "../../assets/images/soundimg/SelectedSounds.svg";
import close_img from "../../assets/images/soundimg/close.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LeftDataAction, RightDataAction, VolumeLevelsAction } from "../../store/actions/therapyAction";
import { isEqual } from "lodash";

function writeString(view, offset, string) {
  for (let i = 0; i < string.length; i++) {
    view.setUint8(offset + i, string.charCodeAt(i));
  }
}

function bufferToWave(abuffer) {
  const numOfChan = abuffer.numberOfChannels,
    length = abuffer.length * numOfChan * 2 + 44,
    buffer = new ArrayBuffer(length),
    view = new DataView(buffer),
    channels = [],
    sampleRate = abuffer.sampleRate;

  writeString(view, 0, "RIFF");
  view.setUint32(4, length - 8, true);
  writeString(view, 8, "WAVE");
  writeString(view, 12, "fmt ");
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, numOfChan, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * 2 * numOfChan, true);
  view.setUint16(32, numOfChan * 2, true);
  view.setUint16(34, 16, true);
  writeString(view, 36, "data");
  view.setUint32(40, length - 44, true);

  for (let i = 0; i < abuffer.numberOfChannels; i++) {
    channels.push(abuffer.getChannelData(i));
  }

  let offset = 44;
  for (let i = 0; i < abuffer.length; i++) {
    for (let j = 0; j < numOfChan; j++) {
      const sample = Math.max(-1, Math.min(1, channels[j][i]));
      view.setInt16(
        offset,
        sample < 0 ? sample * 0x8000 : sample * 0x7fff,
        true
      );
      offset += 2;
    }
  }

  return new Blob([buffer], { type: "audio/wav" });
}

function not(a, b) {
  return a.filter((value) => !b.includes(value));
}

function intersection(a, b) {
  return a.filter((value) => b.includes(value));
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

const MaskingAudioController = () => {
  const navigate = useNavigate();

  const [checked, setChecked] = React.useState([]);
  const {leftdata} = useSelector((state) => state);
  // console.log("lefts actionssss",leftdata?.leftTherapy)
  const [left, setLeft] = React.useState();
  const [loading, setLoading] = useState(false);
  const [dataloading, setDataLoading] = useState(false);
  const icon_img = {
    beach,
    birds,
    brook,
    cicadas,
    crickets,
    fire,
    frog,
    highway,
    rain_thunder,
    under_water,
    whale,
    wind,
    pink_noise,
    white_noise,
    brown_noise,
    violet_noise,
    music,
  };
  
  const dispatch = useDispatch();
  const fetchList = () => {
    setDataLoading(true);
    dispatch(
      callApiAction(
        async () => await FetchAudioApi(),
        async (response) => {
          console.log("first response", response);
          
          if (Array.isArray(response) && response.length > 0) {
            const processedData = await response.map((audio) => {
              const baseName = audio.label.replace(".mp3", "");
              const labelName = audio.label
                .replace(".mp3", "") 
                .replace(/_/g, " ") 
                .replace(/\b\w/g, (char) => char.toUpperCase()); 

              return {
                ...audio,
                label: labelName,
                icon: icon_img[baseName] || music,
              };
            });
            dispatch(LeftDataAction(processedData))
            // setLeft(processedData);
          } else {
            console.error("Invalid response format", response);
            // setLeft([]);
            dispatch(LeftDataAction([]))
          }

          setDataLoading(false);
        },
        (err) => {
          console.error("API Error:", err);
          setDataLoading(false);
        }
      )
    );
  };

  useEffect(() => {
    if(Object.keys(leftdata?.leftTherapy).length === 0){
    fetchList();
    }
  }, [leftdata?.leftTherapy]);
  const location = useLocation();
  const params = useParams();
  const [right, setRight] = React.useState(leftdata?.rightTherapy);
  const [input, setInput] = useState("Untitled therapy");
  const [volumeLevels, setVolumeLevels] = React.useState(leftdata?.VolumeLevel);
  const [mergedAudio, setMergedAudio] = React.useState(null);

  const leftChecked = intersection(
    checked,
    leftdata?.leftTherapy?.map((item) => item.file)
  );
  const rightChecked = intersection(
    checked,
    leftdata?.rightTherapy?.map((item) => item.file)
  );
  const audioContext = React.useRef(
    new (window.AudioContext || window.webkitAudioContext)()
  );
  const [audioNodes, setAudioNodes] = React.useState({});

  const handleVolumeChange = (audioFile, value) => {
    const volume = value / 100;
    if (audioNodes[audioFile]) {
      audioNodes[audioFile].gainNode.gain.setValueAtTime(
        volume,
        audioContext.current.currentTime
      );
    }
    setVolumeLevels((prevLevels) => ({
      ...prevLevels,
      [audioFile]: volume,
    }));
  };

  const handleStopAll = () => {
    Object.keys(audioNodes).forEach((file) => {
      const audio = audioNodes[file].audio;
      if (!audio.paused) {
        audio.pause();
        audio.currentTime = 0;
      }
    });
  };

  const mergeAudioFiles = async (audioFiles) => {
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    const desiredDuration = 2 * 60; // Convert 90 minutes to seconds

    const buffers = await Promise.all(
      audioFiles?.map(async (file,index) => {
        const response = await fetch(file);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        const volume = leftdata?.VolumeLevel[file] ? leftdata?.VolumeLevel[file] + 1 : 1.7; // Get volume level for the file

        const sampleRate = audioBuffer.sampleRate;
        const desiredSamples = sampleRate * desiredDuration; // Total samples for 90 min
        const totalSamples = audioBuffer.length;

        // Create OfflineAudioContext to process audio with gain
        const offlineContext = new OfflineAudioContext(
          audioBuffer.numberOfChannels,
          desiredSamples,
          sampleRate
        );

        // Create source and apply gain
        const source = offlineContext.createBufferSource();
        const gainNode = offlineContext.createGain();
        gainNode.gain.value = volume; // Apply volume level

        // Handling audio length adjustments
        const extendedBuffer = audioContext.createBuffer(
          audioBuffer.numberOfChannels,
          desiredSamples,
          sampleRate
        );

        for (
          let channel = 0;
          channel < audioBuffer.numberOfChannels;
          channel++
        ) {
          const inputData = audioBuffer.getChannelData(channel);
          const outputData = extendedBuffer.getChannelData(channel);

          for (let i = 0; i < desiredSamples; i++) {
            outputData[i] = inputData[i % totalSamples]; // Loop the sound to fill 90 minutes
          }
        }

        source.buffer = extendedBuffer;
        source.connect(gainNode);
        gainNode.connect(offlineContext.destination);
        source.start();

        const renderedBuffer = await offlineContext.startRendering();
        return renderedBuffer;
      })
    );

    // Create final output buffer
    const maxLength = desiredDuration * audioContext.sampleRate;
    const outputBuffer = audioContext.createBuffer(
      buffers[0].numberOfChannels,
      maxLength,
      audioContext.sampleRate
    );

    // Mix buffers
    buffers.forEach((buffer) => {
      for (let channel = 0; channel < buffer.numberOfChannels; channel++) {
        const outputData = outputBuffer.getChannelData(channel);
        const inputData = buffer.getChannelData(channel);

        for (let i = 0; i < maxLength; i++) {
          outputData[i] += inputData[i] / buffers.length; // Normalize mixing
        }
      }
    });

    const audioBlob = new Blob([bufferToWave(outputBuffer)], {
      type: "audio/mp3",
    });
    const downloadUrl = URL.createObjectURL(audioBlob);

    handleStopAll();
    navigate(`/therapyReady/${params.id}`, {
      state: {
        Patient: audioBlob,
        inputdata: input,
        Volume: leftdata?.VolumeLevel,
        PatientFrequency: parseInt(location?.state?.PatientFrequency),
      },
    });
    setLoading(false);

    return downloadUrl;
  };

  const handleMerge = async () => {
    if (leftdata?.rightTherapy?.length > 0) {
     
      const audioFiles = leftdata?.rightTherapy?.map((item) => item.file);
      setLoading(true);
      const url = await mergeAudioFiles(audioFiles);
      setMergedAudio(url);
    } else {
      console.log("Please select files to merge.");
      setLoading(false);
    }
  };

  useEffect(() => {
    const resumeAudioContext = async () => {
      if (audioContext.current.state === "suspended") {
        await audioContext.current.resume();
      }
    };

    leftdata?.rightTherapy?.forEach(async (item) => {
      if (!audioNodes[item.file]) {
        const audio = new Audio(item.file);
        audio.crossOrigin = "anonymous";
        audio.loop = true;

        // Resume context and play audio
        await resumeAudioContext();
        audio.play().catch((error) => {
          console.log("Audio play error:", error);
        });

        // Create audio nodes
        const audioSource =
          audioContext.current.createMediaElementSource(audio);
        const gainNode = audioContext.current.createGain();
        audioSource.connect(gainNode).connect(audioContext.current.destination);

        // Set initial volume
        gainNode.gain.setValueAtTime(
          leftdata?.VolumeLevel[item.file] || 1,
          audioContext.current.currentTime
        );

        setAudioNodes((prevNodes) => ({
          ...prevNodes,
          [item.file]: { audio, gainNode },
        }));
      }
    });

    // Cleanup for items removed from right
    Object.keys(audioNodes).forEach((file) => {
      if (!leftdata?.rightTherapy?.some((item) => item.file === file)) {
        const node = audioNodes[file];
        node.audio.pause();
        node.audio.src = "";
        delete audioNodes[file];
        setAudioNodes((prevNodes) => {
          const newNodes = { ...prevNodes };
          delete newNodes[file];
          return newNodes;
        });
      }
    });
  }, [leftdata?.rightTherapy, audioNodes, leftdata?.VolumeLevel]);

//   const handleSoundSelection = (sound) => {
//     setRight((prev) =>
//       prev.some((item) => item.file === sound.file)
//         ? prev.filter((item) => item.file !== sound.file)
//         : [...prev, sound]
//     );
//   };

useEffect(() => {
  if (!isEqual(leftdata?.rightTherapy, right)) {
    dispatch( RightDataAction(right))
  }
}, [right]);
useEffect(() => {
  if (!isEqual(leftdata?.VolumeLevel, volumeLevels)) {
    dispatch( VolumeLevelsAction(volumeLevels))
  }
}, [volumeLevels]);
const handleSoundSelection = (sound) => {
    setRight((prev) => {
        // Check if the sound is already selected
        const isSelected = prev.some((item) => item.file === sound.file);

        if (isSelected) {
            // If already selected, allow unselecting
            return prev.filter((item) => item.file !== sound.file);
        }

        // If not selected, only add if there are less than 5 selected
        if (prev.length < 5) {
            return [...prev, sound];
        }

        // Otherwise, return the existing state (do not add more than 5)
        return prev;
    });
};


  const customList = (items) => (
    <>
      {items.length === 0 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "60vh",
            width: "100%",
          }}
        >
          <img src={SelectedSounds_img} height={"70%"} width={"80%"} />
        </Box>
      )}
      {items?.map((item) => (
        <>
          <Box my={3} width={"100%"} display={"flex"} justifyContent={"center"}>
            <Badge
              badgeContent={
                <img
                  src={close_img}
                  onClick={() => !loading && handleSoundSelection(item)}
                />
              }
              color="#FFFFFF"
            >
              <Card
                //  ref={drag}
                sx={{
                  marginLeft: "10px",
                  border: "1px solid #DEDEDE",
                  marginBottom: "5px",
                  height: "84px",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "35vw",
                  display: "flex",
                  position: "relative",
                  overflow: "visible",
                  zIndex: 1,
                }}
              >
                <Box
                  key={item.file}
                  sx={{ display: "flex", flexDirection: "row", width: "100%" }}
                >
                  {leftdata?.rightTherapy.includes(item) && (
                    <>
                      <Card
                        variant="outlined"
                        //    onClick={() => handleSoundSelection(item)}
                        sx={{
                          cursor: "pointer",

                          backgroundColor: "",
                          border: "1px solid #e0e0e0",
                          textAlign: "center",
                          //  padding: 1,
                          height: "84px",
                          alignItems: "center",
                          alignContent: "center",
                          justifyContent: "center",
                          width: "110px",
                        }}
                      >
                        <img src={item.icon} />
                        <Typography
                          className="AxiformaRegular"
                          sx={{
                            fontSize: "12px",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#666666",
                          }}
                        >
                          {item.label}
                        </Typography>
                      </Card>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-around",
                          alignItems: "center",
                          width: "75%",
                        }}
                      >
                        <Slider
                          value={
                            typeof leftdata?.VolumeLevel[item.file] !== "undefined"
                              ? leftdata?.VolumeLevel[item.file] * 100
                              : 70
                          }
                          onChange={(e, newValue) =>
                            !loading && handleVolumeChange(item.file, newValue || 70)
                          }
                          min={0}
                          max={100}
                          sx={{
                            width: "20.703125vw",
                            zIndex: 3,
                            position: "relative",
                            height: "6px",
                            "& .MuiSlider-valueLabel": {
                              backgroundColor: "white",
                              color: "black",
                              boxShadow:
                                "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                              zIndex: 10,
                            },
                          }}
                          valueLabelDisplay="auto"
                        />
                      </Box>
                    </>
                  )}
                </Box>
              </Card>
            </Badge>
          </Box>
        </>
      ))}
    </>
  );

  const SoundCard = ({ sound }) => {
    const [{ isDragging }, drag] = useDrag({
      type: "SOUND",
      item: { sound },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });

    return (
      <>
        <Card
          disable={loading}
          ref={drag}
          variant="outlined"
          onClick={() =>
            !loading  && handleSoundSelection(sound)
          }
          sx={{
            cursor: "pointer",
            width: "100px",
            backgroundColor: leftdata?.rightTherapy?.some((item) => item.file === sound.file)
              ? "rgba(211, 70, 70, 0.1)"
              : "",
            border: leftdata?.rightTherapy?.some((item) => item.file === sound.file)
              ? "2px solid rgba(211, 70, 70, 0.7)"
              : "1px solid #e0e0e0",
            opacity: isDragging ? 0.5 : 1,
            textAlign: "center",
            padding: 1,
            height: "92.25px",
            minHeight: "92.25px",
            alignItems: "center",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <CardContent>
            <img src={sound.icon} />
          </CardContent>
        </Card>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100px",
          }}
        >
          <Typography
            className="AxiformaRegular"
            sx={{
              wordWrap: "break-word",
              textAlign: "center",
              maxWidth: "100%",
              fontSize: "16px",
              color: "#666666",
              minHeight: "40px", // Ensures all cards have uniform text height
            }}
          >
            {sound.label}
          </Typography>
        </Box>
      </>
    );
  };
console.log("leftdata?.rightTherapy",leftdata?.rightTherapy)
  return (
    <DndProvider backend={HTML5Backend}>
      <MaskingAudioUi
        customList={customList}
        leftChecked={leftChecked}
        rightChecked={rightChecked}
        handleSoundSelection={handleSoundSelection}
        handleMerge={handleMerge}
        right={leftdata?.rightTherapy}
        left={leftdata?.leftTherapy}
        SoundCard={SoundCard}
        mergedAudio={mergedAudio}
        handleStopAll={handleStopAll}
        setRight={setRight}
        setChecked={setChecked}
        checked={checked}
        // handleToggle={handleToggle}
        loading={loading}
        dataloading={dataloading}
        input={input}
        setInput={setInput}
      />
    </DndProvider>
  );
};

export default MaskingAudioController;

// const mergeAudioFiles = async (audioFiles) => {
//     const audioContext = new (window.AudioContext || window.webkitAudioContext)();
//     const desiredDuration = 90;

//     const buffers = await Promise.all(
//         audioFiles?.map(async (file) => {
//             const response = await fetch(file);
//             const arrayBuffer = await response.arrayBuffer();
//             const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

//             const volume = volumeLevels[file] || 1; // Get volume level for the file

//             const offlineContext = new OfflineAudioContext(
//                 audioBuffer.numberOfChannels,
//                 Math.ceil(audioBuffer.sampleRate * desiredDuration),
//                 audioBuffer.sampleRate
//             );

//             // Create source and apply gain
//             const source = offlineContext.createBufferSource();
//             source.buffer = audioBuffer;

//             const gainNode = offlineContext.createGain();
//             gainNode.gain.value = volume; // Apply the volume level

//             // Connect the processing nodes
//             source.connect(gainNode);
//             gainNode.connect(offlineContext.destination);

//             source.start();
//             const renderedBuffer = await offlineContext.startRendering();

//             return renderedBuffer;
//         })
//     );

//     // Create the final output buffer
//     const maxLength = Math.ceil(desiredDuration * audioContext.sampleRate);
//     const outputBuffer = audioContext.createBuffer(
//         buffers[0].numberOfChannels,
//         maxLength,
//         audioContext.sampleRate
//     );

//     // Mix the buffers with proper volume adjustment
//     buffers.forEach((buffer) => {
//         for (let channel = 0; channel < buffer.numberOfChannels; channel++) {
//             const outputData = outputBuffer.getChannelData(channel);
//             const inputData = buffer.getChannelData(channel);

//             for (let i = 0; i < maxLength; i++) {
//                 outputData[i] += inputData[i % inputData.length] / buffers.length; // Normalize mixing
//             }
//         }
//     });

//     const audioBlob = new Blob([bufferToWave(outputBuffer)], { type: "audio/mp3" });
//     const downloadUrl = URL.createObjectURL(audioBlob);

//     handleStopAll();
//     navigate(/therapyReady/${params.id}, {
//         state: {
//             Patient: audioBlob,
//             inputdata: input,
//             Volume: volumeLevels,
//             PatientFrequency: parseInt(location?.state?.PatientFrequency),
//         },
//     });
//     setLoading(false);

//     return downloadUrl;
// };
